/* VigorX — cart-add notification for third-party add paths (2026-08-31).
 *
 * Dawn's product-form.js opens <cart-notification> only for adds IT performs.
 * The Vitals bundle box (and any other app) posts to /cart/add.js through its
 * own fetch/XHR, so the shopper got no confirmation: the bubble count moved and
 * nothing else. This watches the network for successful cart adds that Dawn did
 * not initiate, pulls the three notification sections through the Section
 * Rendering API, and opens the SAME notification Dawn uses.
 *
 * Rules kept: no Vtl- class is touched, no location.reload(), theme-owned only.
 */
(function () {
  'use strict';
  if (window.vxAtcNotify) return;
  window.vxAtcNotify = true;

  var ADD_RE = /\/cart\/add(?:\.js)?(?:[?#]|$)/;
  var busy = false;

  function dawnOwnAdd(body) {
    /* Dawn's product-form appends a 'sections' field to its FormData and
       renders the notification from that same response — firing again would
       double-open. Anything else (JSON bodies, plain FormData) is not Dawn. */
    try {
      return body instanceof FormData && typeof body.has === 'function' && body.has('sections');
    } catch (e) { return false; }
  }

  function keyFrom(json) {
    if (!json) return null;
    if (json.items && json.items.length) return json.items[0].key;
    return json.key || null;
  }

  function show(key) {
    if (busy) return;
    var el = document.querySelector('cart-notification');
    if (!el || typeof el.renderContents !== 'function') return;
    busy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-notification-product,cart-notification-button,cart-icon-bubble', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (sections) el.renderContents({ key: key, sections: sections });
      })
      .catch(function () {})
      .finally(function () { setTimeout(function () { busy = false; }, 400); });
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var isAdd = ADD_RE.test(url) && !/^(GET|HEAD)$/i.test(method);
    var own = isAdd && dawnOwnAdd(init && init.body);
    var out = origFetch.apply(this, arguments);
    if (isAdd && !own) {
      out.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (json) {
          var k = keyFrom(json);
          if (k) show(k);
        }).catch(function () {});
      }, function () {});
    }
    return out;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__vxAtc = ADD_RE.test(String(u || '')) && !/^(GET|HEAD)$/i.test(m || 'GET');
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__vxAtc && !dawnOwnAdd(body)) {
      this.addEventListener('loadend', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { var k = keyFrom(JSON.parse(this.responseText)); if (k) show(k); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };
})();
